import React from "react";

export function AddIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M9.32968 1.23383C9.27878 0.543919 8.70291 0 8 0C7.26362 0 6.66667 0.596954 6.66667 1.33333V6.66667H1.33333L1.23383 6.67032C0.543919 6.72122 0 7.29709 0 8C0 8.73638 0.596954 9.33333 1.33333 9.33333H6.66667V14.6667L6.67032 14.7662C6.72122 15.4561 7.29709 16 8 16C8.73638 16 9.33333 15.403 9.33333 14.6667V9.33333H14.6667L14.7662 9.32968C15.4561 9.27878 16 8.70291 16 8C16 7.26362 15.403 6.66667 14.6667 6.66667H9.33333V1.33333L9.32968 1.23383Z" fill="#3EC1CB"/>
        </svg>
    );
}
